import {Organization, Role, User} from "../types/userTypes";
import {GridColDef, GridValueGetter} from "@mui/x-data-grid";

export const enum EntityType {
    users = "users",
    organizations = "organizations",
}

export const defaultUser: User = {
    id: '',
    email: '',
    name: '',
    surname: '',
    username: '',
    roles: [],
    password: "",
    organizations: []
}

export const defaultOrganization: Organization = {
    id: '',
    name: '',
    users: [],
    competitions: [],
    teams: []
}

export const defaultRole: Role = {
    id: '',
    name: '',
    description: '',
    permissions: []
}

export const userColumns: GridColDef[] = [
    { field: "id", headerName: "Id", headerClassName: 'super-app-theme--header', flex: 1, minWidth: 250 },
    { field: "email", headerName: "Email", headerClassName: 'super-app-theme--header', flex: 1, minWidth: 250 },
    { field: "username", headerName: "Username", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "name", headerName: "Name", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "surname", headerName: "Surname", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "roles", headerName: "Role", headerClassName: 'super-app-theme--header', flex: 1, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r.name).join(", ")
                : params;
        }, },
    { field: "organizations", headerName: "Organization", headerClassName: 'super-app-theme--header', flex: 1, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r ? r.name : '').join(", ")
                : params;
        }, }
]

export const organizationColumns: GridColDef[] = [
    { field: "id", headerName: "Id", headerClassName: 'super-app-theme--header', flex: 1, minWidth: 250 },
    { field: "name", headerName: "Name", headerClassName: 'super-app-theme--header', flex: 1 },
    { field: "users", headerName: "Users", headerClassName: 'super-app-theme--header', flex: 2, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r.email).join(", ")
                : params;
        },
    },
    { field: "competitions", headerName: "Competition", headerClassName: 'super-app-theme--header', flex: 2, valueGetter: (params: GridValueGetter<User>) => {
            return Array.isArray(params)
                ? params.map((r: any) => r.name + " - " + r.season).join(", ")
                : params;
        }, }
]

export enum APP_PERMISSION {
    COMPUTE_WINDOW = 'compute_window',
    CREATE_COLLECTION = 'create_collection',
    CREATE_DATA_SOURCE = 'create_data_source',
    CREATE_EVENT = 'create_event',
    CREATE_FEED_SOURCE = 'create_feed_source',
    CREATE_JOB = 'create_job',
    CREATE_KEY_MOMENT = 'create_key_moment',
    CREATE_LOGIC_CLIP = 'create_logic_clip',
    CREATE_LOGIC_HIGHLIGHT = 'create_logic_highlight',
    CREATE_MATCHDAY = 'create_matchday',
    CREATE_ORGANIZATION = 'create_organization',
    CREATE_ROLE = 'create_role',
    CREATE_SOCIAL_ACCOUNT = 'create_social_account',
    CREATE_TRACK = 'create_track',
    CREATE_USER = 'create_user',
    DELETE_COLLECTION = 'delete_collection',
    DELETE_DATA_SOURCE = 'delete_data_source',
    DELETE_EVENT = 'delete_event',
    DELETE_FILE = 'delete_file',
    DELETE_JOB = 'delete_job',
    DELETE_KEY_MOMENT = 'delete_key_moment',
    DELETE_LOGIC_CLIP = 'delete_logic_clip',
    DELETE_MATCHDAY = 'delete_matchday',
    DELETE_ORGANIZATION = 'delete_organization',
    DELETE_PUBLICATION = 'delete_publication',
    DELETE_ROLE = 'delete_role',
    DELETE_RULE = 'delete_rule',
    DELETE_TRACK = 'delete_track',
    DELETE_USER = 'delete_user',
    GET_COLLECTION = 'get_collection',
    GET_COMPETITION = 'get_competition',
    GET_DATA_SOURCE = 'get_data_source',
    GET_EDITORIAL_ASSET = 'get_editorial_asset',
    GET_EVENT = 'get_event',
    GET_FEED_SOURCE = 'get_feed_source',
    GET_JOB = 'get_job',
    GET_KEY_MOMENT = 'get_key_moment',
    GET_LOGIC_CLIP = 'get_logic_clip',
    GET_MATCHDAY = 'get_matchday',
    GET_ORGANIZATION = 'get_organization',
    GET_PUBLICATION = 'get_publication',
    GET_ROLE = 'get_role',
    GET_RULE = 'get_rule',
    GET_SOCIAL_ACCOUNT = 'get_social_account',
    GET_TEAM = 'get_team',
    GET_TRACK = 'get_track',
    GET_USER = 'get_user',
    MATERIALIZE_LOGIC_CLIP = 'materialize_logic_clip',
    PUBLISH = 'publish',
    RENDER_ASSET = 'render_asset',
    REVERT_KEY_MOMENT = 'revert_key_moment',
    START_JOB = 'start_job',
    STOP_JOB = 'stop_job',
    UPDATE_COLLECTION = 'update_collection',
    UPDATE_DATA_SOURCE = 'update_data_source',
    UPDATE_EVENT = 'update_event',
    UPDATE_JOB = 'update_job',
    UPDATE_KEY_MOMENT = 'update_key_moment',
    UPDATE_LOGIC_CLIP = 'update_logic_clip',
    UPDATE_MATCHDAY = 'update_matchday',
    UPDATE_ORGANIZATION = 'update_organization',
    UPDATE_ROLE = 'update_role',
    UPDATE_RULE = 'update_rule',
    UPDATE_SOCIAL_ACCOUNT = 'update_social_account',
    UPDATE_TRACK = 'update_track',
    UPDATE_USER = 'update_user',
    UPLOAD_FILE = 'upload_file'
}

export const adminUser = (import.meta as any).env.VITE_ADMIN_EMAIL


